<template>
  <div id="app" :class="'theme-' + theme">
    <div class="container">
      <NavBar />
      <router-view/>
    </div>
    <LightSwitch />
  </div>
</template>

<style lang="stylus">

</style>

<script>
import { mapState } from 'vuex'

import NavBar from '@/components/NavBar.vue'
import LightSwitch from '@/components/LightSwitch.vue'

export default {
  computed: {
    ...mapState(['theme'])
  },
  components: {
    NavBar,
    LightSwitch
  }
}
</script>
